import React, { Component } from "react";
import { withStyles, Box, Button, CircularProgress } from "@material-ui/core";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";

import AccountInfo from "../../components/Accounts/AccountInfo";
import AccountLabel from "../../components/Accounts/AccountLabel";
import AccountAuth from "../../components/Accounts/AccountAuth";
import {styles} from "./styles";
import {LoadingOverlay} from "../../components/LoadingOverlay";

@inject('clientStore', 'shipmentStore')
@observer
class GeneralSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  componentDidMount() {
    this.setState({loading: true});
    this.fetchData();
  }

  fetchData = async () => {
    const {clientStore} = this.props;

    await clientStore.get();
    await clientStore.getToken();
    await clientStore.getTelephonies();
    this.setState({loading: false})
  }

  validateAndUpdateClient = async (e) => {
    const {clientStore} = this.props;
    const isValid = await clientStore.validateClientInfo();
    if(isValid){
      await clientStore.updateInfo();
    }
  }

  goBack = () => {
    this.props.history.push("/");
  }

  render() {
    const {clientStore, classes} = this.props;
    const {savingInfo} = clientStore;
    const {loading} = this.state;

    return (
      <>
        <Box className={classes.wrapper}>
          {loading && <LoadingOverlay />}
          <Box component="h3" className={classes.headerTitle}>Organization Information</Box>
          <AccountInfo />
        </Box>

        <Box className={classes.wrapper}>
          <Box component="h3" className={classes.headerTitle}>Label Settings</Box>
          <AccountLabel />
        </Box>

        <Box className={classes.wrapper}>
          <Box component="h3" className={classes.headerTitle}>Public API Authentication</Box>
          <AccountAuth />
        </Box>

        <Box align="right">
          <Button onClick={this.goBack} variant="outlined" color="primary" disableElevation className={classes.button}>
            Cancel
          </Button>
          <Button disabled={savingInfo} onClick={this.validateAndUpdateClient} variant="contained" disableElevation color="primary" className={classes.button}>
            {!savingInfo ? 'Save' : <CircularProgress color="inherit" size={24} />}
          </Button>
        </Box>
      </>
    );
  }
}

export default withStyles(styles)(withRouter(GeneralSettings));